<div class="dialog-header">
  <div class="column"></div>
  <div class="dialog-title-container">
    <mat-icon class="submit-icon" [h3CustomIcon]="submitTaskIcon"></mat-icon>
    <span class="subtitle-01 dialog-title">Submit Task</span>
  </div>
  <div class="column close-button-container">
    @if ((isLoading$ | async) === false) {
      <button mat-icon-button mat-dialog-close>
        <mat-icon class="material-icons-outlined">close</mat-icon>
      </button>
    }
  </div>
</div>

@if ((isLoading$ | async) === false) {
  <span class="confirmation-text body-02"
    >Please review your work before submitting. You will not be able to make any
    further changes. Are you sure you want to submit?</span
  >

  <div class="annotation-count-container">
    @if (objectCount > 0) {
      <div class="annotation-count">
        <mat-icon svgIcon="object" [inline]="true"></mat-icon>
        <span class="body-02">{{
          objectCount | i18nPlural: { '=1': '1 Object', other: '# Objects' }
        }}</span>
      </div>
    }
    @if (shapeCount > 0) {
      <div class="annotation-count">
        <mat-icon svgIcon="rectangle-shape-type" [inline]="true"></mat-icon>
        <span class="body-02">{{
          shapeCount | i18nPlural: { '=1': '1 Shape', other: '# Shapes' }
        }}</span>
      </div>
    }
  </div>

  <mat-dialog-actions class="buttons-container">
    <button mat-button color="primary" (click)="submitAndStopWork()">
      <span class="label-with-icon"
        ><mat-icon class="material-symbols-outlined"> stop_circle </mat-icon
        >SUBMIT & STOP</span
      >
    </button>
    <button mat-button color="primary" (click)="submitAndLoadNext()">
      <span class="label-with-icon"
        ><mat-icon class="material-icons-outlined"> skip_next </mat-icon>SUBMIT
        & LOAD NEXT</span
      >
    </button>
  </mat-dialog-actions>
} @else {
  <div class="loading-container">
    <span class="caption">{{ progressText() }}</span>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
}
